module.exports = __webpack_public_path__ + "favicon.dba6cbe2e1a683e514d7d0c11339f87e.ico";